var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 224.88 225",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7760ba0371"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 36 47.113281 L 790 47.113281 L 790 762.613281 L 36 762.613281 Z M 36 47.113281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7760ba0371)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#313f52",
    d: "M 84.101562 155.054688 L 68.773438 155.582031 L 76.628906 147.628906 Z M 84.101562 155.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#313f52",
    d: "M 153.636719 115.597656 C 150.789062 137.707031 130.476562 153.328125 108.273438 150.488281 C 86.070312 147.652344 70.382812 127.429688 73.230469 105.320312 C 76.078125 83.210938 96.386719 67.585938 118.59375 70.425781 C 140.796875 73.261719 156.488281 93.488281 153.636719 115.597656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#313f52",
    d: "M 123.769531 98.984375 C 126.429688 101.804688 123.804688 108.46875 123.804688 108.46875 C 123.804688 108.46875 121.203125 117.894531 106.332031 130.113281 L 103.550781 127.402344 L 122.4375 108.183594 L 122.800781 107.695312 C 123.304688 106.878906 123.71875 98.929688 123.769531 98.984375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 164.985437 87.530573 C 172.965616 96.027515 165.090902 116.104776 165.090902 116.104776 C 165.090902 116.104776 157.286499 144.502449 112.674842 181.314684 L 104.331396 173.147263 L 160.989489 115.245667 L 162.079293 113.77459 C 163.590957 111.314949 164.833099 87.365813 164.985437 87.530573 Z M 164.985437 87.530573 ",
    stroke: "#ffffff",
    strokeWidth: 1.918,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fillOpacity: 1,
    fill: "#313f52",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "M 92.097466 161.107968 L 164.856536 87.318738 C 168.559526 91.708432 169.344654 96.427648 168.266568 103.171065 C 167.55175 107.831438 159.489544 117.152183 159.489544 117.152183 L 104.331396 173.147263 ",
    stroke: "#ffffff",
    strokeWidth: 1.201,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#313f52",
    d: "M 123.769531 99 L 99.472656 123.40625 L 99.523438 123.359375 L 99.511719 123.363281 L 93.484375 117.449219 C 106.054688 101.878906 114.179688 98.976562 114.179688 98.976562 C 114.179688 98.976562 119.472656 96.921875 123.246094 98.515625 C 123.539062 98.671875 123.664062 98.761719 123.769531 99.003906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 164.985437 87.577648 L 92.097466 161.107968 L 92.249804 160.966744 L 92.214649 160.978513 L 74.133277 143.160827 C 111.842841 96.251118 136.216954 87.507036 136.216954 87.507036 C 136.216954 87.507036 152.095282 81.316743 163.415182 86.118339 C 164.294056 86.589084 164.669043 86.859762 164.985437 87.589416 Z M 164.985437 87.577648 ",
    stroke: "#ffffff",
    strokeWidth: 1.918,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#10b9842c04)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fillOpacity: 1,
    fill: "#313f52",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "M 112.674842 181.314684 C 95.273132 195.637091 73.020036 218.138687 42.775043 233.826254 L 49.501361 262.588754 L 20.99068 234.497065 L 92.097466 161.107968 ",
    stroke: "#ffffff",
    strokeWidth: 1.918,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fillOpacity: 1,
    fill: "#313f52",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "M 74.625446 143.396199 L 92.284959 161.00205 L 51.481758 169.840282 L 74.227023 143.078446 Z M 74.625446 143.396199 ",
    stroke: "#ffffff",
    strokeWidth: 1.918,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    d: "M 121.449219 91.917969 C 120.871094 97.109375 124.625 101.785156 129.839844 102.363281 C 135.046875 102.941406 139.746094 99.199219 140.328125 94.007812 C 140.910156 88.820312 137.148438 84.140625 131.933594 83.566406 C 126.722656 82.992188 122.027344 86.726562 121.449219 91.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 158.024753 66.241145 C 156.290442 81.881637 167.55175 95.968672 183.195712 97.710427 C 198.816237 99.452182 212.91338 88.177847 214.65941 72.537355 C 216.40544 56.908631 205.120695 42.809828 189.476733 41.079841 C 173.84449 39.349854 159.759065 50.600652 158.024753 66.241145 Z M 158.024753 66.241145 ",
    stroke: "#ffffff",
    strokeWidth: 1.918,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M 138.964844 98.191406 C 140.714844 95.640625 140.625 91.828125 140.273438 90.699219 C 139.839844 89.316406 138.875 87.066406 137.191406 85.898438 L 128.289062 94.0625 C 128.289062 94.0625 135.132812 101.386719 135.308594 101.410156 C 135.382812 101.417969 137.363281 100.515625 138.964844 98.191406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 210.569715 85.141544 C 215.819524 77.456637 215.550003 65.970466 214.495354 62.569336 C 213.19462 58.403246 210.300194 51.624522 205.249596 48.105706 L 178.543538 72.702115 C 178.543538 72.702115 199.07404 94.768273 199.601365 94.838884 C 199.824013 94.862422 205.765203 92.143871 210.569715 85.141544 Z M 205.179287 65.864549 C 205.179287 65.864549 207.745599 72.172528 204.487905 77.080041 Z M 205.179287 65.864549 ",
    stroke: "#ffffff",
    strokeWidth: 1.918,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M 103.761719 127.40625 L 93.933594 129.144531 L 99.867188 123.007812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.333345, 0, 0, 0.331921, 68.772383, 69.931148)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 104.964185 173.159032 L 75.480884 178.396067 L 93.281017 159.907569 M 75.305109 143.525654 L 112.792025 178.7962 ",
    stroke: "#ffffff",
    strokeWidth: 1.918,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostman);
export default __webpack_public_path__ + "static/media/postman.6d20d6f3778edbf102baa55be4e6f7a5.svg";
export { ForwardRef as ReactComponent };